<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!pincodeId">Add Pin Code</span>
                <span *ngIf="pincodeId">Update Pin Code</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="pinCodeForm" (submit)="createPinCode()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Circle *</label>
                                    <mat-select (selectionChange)="getCircleZone($event.value)" placeholder="Circle"
                                        [disabled]="diss_circle_city" formControlName="circle_id"
                                        (click)="setSearchValue('circle')">
                                        <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="circleSearch">
                                        <mat-option>All</mat-option>
                                        <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Zone *</label>
                                    <mat-select  placeholder="Zone"
                                        [disabled]="diss_circle_city"  formControlName="zone_id"
                                        (click)="setSearchValue('zone')">
                                        <input class="mySearchInput" #zoneSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'zones')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="zoneSearch">
                                            <mat-option [value]="zone.id" *ngFor="let zone of zones">
                                                {{zone.zone_name}}
                                            </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.zone_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.zone_id.errors.required">Zone is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Pin Code *</label>
                                    <input type="number" formControlName="pin_code" class="form-control"
                                        onkeypress="if (this.value.length > 7) return false;" />
                                    <div *ngIf="submitted && f.pin_code.errors" class="invalid-feedback">
                                        <div *ngIf="f.pin_code.errors.required">Pin code is required</div>
                                        <div *ngIf="!f.pin_code.valid && f.pin_code.value">Your Pin code must be minimum 6 characters.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!pincodeId">Create Pin Code</span>
                        <span *ngIf="pincodeId">Update Pin Code</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>